import Dashboard from '@components/Dashboard/Dashboard';
import Layout from '@components/Layout';

const AdminDashboard = () => <Dashboard />;

AdminDashboard.Layout = Layout;

export default AdminDashboard;
